var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitiSolleciti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.983,
    height: 34.947,
    viewBox: "0 0 33.983 34.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inviti_e_solleciti",
    "data-name": "Inviti e solleciti",
    transform: "translate(436.574 -3.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20860",
    "data-name": "Path 20860",
    d: "M75.717,22.545V5.274A.777.777,0,0,1,76.5,4.5H99.047a.777.777,0,0,1,.781.774V22.545",
    transform: "translate(-507.217 -0.008)",
    fill: "none",
    stroke: "#045195",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20861",
    "data-name": "Path 20861",
    d: "M115.13,42.948V27.9a1.5,1.5,0,0,1-1.484-1.484H96.505A1.5,1.5,0,0,1,95.021,27.9V42.948",
    transform: "translate(-524.661 -19.756)",
    fill: "none",
    stroke: "#045195",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20862",
    "data-name": "Path 20862",
    d: "M199.987,91.89l-2.163-2.869-2.2,2.869-1.468-1.127v3.586H201.5V90.763Z",
    transform: "translate(-617.303 -78.266)",
    fill: "none",
    stroke: "#045195",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    "data-name": "Line 421",
    x2: 11.475,
    transform: "translate(-425.267 19.362)",
    fill: "none",
    stroke: "#045195",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    "data-name": "Line 422",
    x2: 11.475,
    transform: "translate(-425.267 21.426)",
    fill: "none",
    stroke: "#045195",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_423",
    "data-name": "Line 423",
    x2: 5.225,
    transform: "translate(-422.143 23.488)",
    fill: "none",
    stroke: "#045195",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20863",
    "data-name": "Path 20863",
    d: "M32.73,157.775l2.646,1.4A2.079,2.079,0,0,1,36.466,161v17.183a2.083,2.083,0,0,1-2.086,2.08H6.586a2.083,2.083,0,0,1-2.086-2.08V161a2.079,2.079,0,0,1,1.089-1.829L8.5,157.6",
    transform: "translate(-440.064 -142.328)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20864",
    "data-name": "Path 20864",
    d: "M4.5,235.254l15.042,7.7a2.091,2.091,0,0,0,1.905,0l15.017-7.7",
    transform: "translate(-440.064 -214.927)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    "data-name": "Line 424",
    x2: 7.326,
    y2: 7.326,
    transform: "translate(-414.714 27.097)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    y1: 8.075,
    x2: 8.075,
    transform: "translate(-431.781 27.339)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitiSolleciti);
export default __webpack_public_path__ + "static/media/inviti_solleciti.aabd2b20b57e92e67b73ec303cd33542.svg";
export { ForwardRef as ReactComponent };